import { useMutation } from '@tanstack/react-query';
import { fetcher } from 'shared/utils/fetcher';
import {
  ApiMembersReferFriendBody,
  ApiMembersReferFriendResponse
} from '../../../api/members/refer-friend/types';
import { apiRoutes } from '../../../constants/routes';
import { StoreCode } from '../../../schema/storeCode';
import { useStoreValue } from '../../hooks/useStore';
import { ReferFriendMutationVariables } from './types';

async function service(customerId: string, store: StoreCode | undefined) {
  if (!store) {
    throw new Error('Store not found');
  }

  const { data } = await fetcher.post<ApiMembersReferFriendResponse>(
    apiRoutes.members.referFriends({ store }),
    {
      id: customerId
    } as ApiMembersReferFriendBody
  );

  return data;
}

export function useMutationReferFriend() {
  const store = useStoreValue();

  return useMutation({
    mutationFn: ({ customerId }: ReferFriendMutationVariables) => service(customerId, store)
  });
}
